import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

const PLAIN_DECIMAL = /^-?\d+\.\d{3,}$/;

/**
 * Display-boundary rounding: plain decimal strings with more than two
 * fraction digits render as two (aggregate artifacts like
 * "333999.83000000004" become "333999.83"). Integers, short decimals,
 * and non-numeric strings pass through untouched; download and copy
 * paths keep the raw value.
 */
export function formatDecimalForDisplay(value: string): string {
  if (!PLAIN_DECIMAL.test(value)) return value;
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(2) : value;
}
